import Utils from "../../utils/Utils";
import ResourcesDispatcher from "../../config/ResourcesDispatcher";
export default class FreeSpinReel {
    constructor(x, y, index, freeSpinCellCreation) {
        this.index = 0;
        this.spinProgressValue = { value: 0 };
        this.spinAnimationDuration = 50;
        this.virtualReelPosition = 0;
        this.realMemoIndex = 0;
        this.spinMainButtonTween = null;
        this.index = index;
        this.numOfCellsPerReel = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_CELLS_PER_REEL;
        this.numOfExtraCellsPerReel = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_EXTRA_CELLS_PER_REEL;
        this.lastCellIndex = ResourcesDispatcher.GAME_CONSTANTS.LAST_CELL_INDEX;
        this.cellSize = ResourcesDispatcher.GAME_CONSTANTS.CELL_SIZE;
        this.container = layoutBuilder.findByPath(`FreeSpin/grid/reel_${index}`);
        this.freeSpinCells = freeSpinCellCreation.cells;
        this.cellPosition = freeSpinCellCreation.cellPositions;
    }
    setIndex(index) {
        this.index = index;
    }
    getIndex() {
        return this.index;
    }
    getContainer() {
        return this.container;
    }
    resetFlagsAndCounters() {
        this.turnOn();
        this.virtualReelPosition = Utils.getRandomInt(0, scene.freeSpinGameArea.virtualGrid[this.index].length - 1);
        this.spinProgressValue = { value: 0 };
        this.stopped = false;
        this.forced = false;
        this.canStop = false;
        this.mustStop = false;
        this.mustEnableStop = false;
        this.realMemoIndex = 0;
        this.removeStopEvent();
    }
    turnOn() {
        this.freeSpinCells.forEach((cell) => {
            cell.turnOn();
        });
    }
    turnOff() {
        this.freeSpinCells.forEach((cell) => {
            cell.turnOff();
        });
    }
    resetCellsPositions() {
        this.freeSpinCells.forEach((cell, index) => {
            cell.getContainer().y = (this.cellSize.height * index) - (this.cellSize.height / 2);
        });
    }
    reIndexCells() {
        let freeSpinCells = [];
        for (let i = 1; i < this.numOfCellsPerReel + this.numOfExtraCellsPerReel; i++) {
            freeSpinCells[i - 1] = this.freeSpinCells[i];
            this.freeSpinCells[i].setIndex(i - 1);
        }
        this.freeSpinCells[0].setIndex(this.lastCellIndex);
        freeSpinCells[this.lastCellIndex] = this.freeSpinCells[0];
        this.freeSpinCells = [];
        this.freeSpinCells = freeSpinCells;
    }
    configureFreeSpinTween() { }
    spin(mainButtonBackground) {
        this.spinProgress.play();
        if (mainButtonBackground) {
            if (window.isButtonSpinning === false) {
                window.isButtonSpinning = true;
                this.spinMainButtonTween = Utils.spinMainButtonRotation(mainButtonBackground);
            }
        }
    }
    bounce() { }
    removeStopEvent() {
        if (this.stopEvent) {
            this.stopEvent.remove(false);
        }
        this.stopEvent = undefined;
    }
    refreshCellPositions() {
        const numOfCells = this.numOfCellsPerReel + this.numOfExtraCellsPerReel;
        for (let i = 0; i < numOfCells; i++) {
            const node = layoutBuilder.getNodeByPath(`FreeSpin/grid/reel_${this.index}/cell_${i}`);
            if (node) {
                this.cellPosition[i] = {
                    x: node.coordinates.relative_top_left_to_parent?.x || 0,
                    y: node.coordinates.relative_top_left_to_parent?.y || 0
                };
            }
        }
        this.freeSpinCells.forEach(cell => {
            const pos = this.cellPosition[cell.getIndex()];
            if (pos) {
                cell.getContainer().setPosition(pos.x, pos.y);
                cell.refreshInternalPositions();
            }
        });
    }
}
